// extracted by mini-css-extract-plugin
export const footer = "footer-module--footer--JWrvW";
export const footerFrame = "footer-module--footerFrame--34OE_";
export const footerNavigation = "footer-module--footerNavigation--Dy6Mn";
export const companyName = "footer-module--companyName--3vic5";
export const navItem = "footer-module--navItem--2NNJ0";
export const navLabel = "footer-module--navLabel--2EuQ1";
export const address = "footer-module--address--31TJW";
export const mapLabel = "footer-module--mapLabel--AkZbt";
export const copyright = "footer-module--copyright--1FMDX";